export default "__VITE_ASSET__BRftU_$i__";